import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Business} from "api/entities/Business";
import {AddonDetails} from "api/entities/Addon";
import {ProductDetails} from "../api/entities/Product";
import {ProductGroup} from "../api/entities/ProductGroup";
import {
    deleteBusinessBuilder,
    getBusinessBuilder,
    setBusinessBuilder,
} from "localStorage/LocalStoreManagerService";

export interface BusinessBuilder extends Business {
    productId?: string;
    productGroupId?: string;
    addons?: AddonDetails[];
    product?: ProductDetails;
    productGroup?: ProductGroup;
    discount?: number;
    isOverrideSetupFee: boolean;
    overrideSetupFee: number;
    isCreated: boolean;
}

const initialBusinessBuilder: BusinessBuilder = {
    name: "",
    clientFirstName: "",
    clientLastName: "",
    address: {
        street: "",
        city: "",
        state: "",
        zip: "",
        country: "usa",
    },
    phone: "",
    email: "",
    website: "",
    description: "",
    discount: 0,
    isOverrideSetupFee: false,
    overrideSetupFee: 0,
    isCreated: false,
};

const initialState = {
    businessBuilder: getBusinessBuilder() ?? initialBusinessBuilder,
};

export const NewOrderCreateSlice = createSlice({
    name: "newOrderCreate",
    initialState: initialState,
    reducers: {
        initializeBusinessAction: (state) => {
            deleteBusinessBuilder();
            setBusinessBuilder(initialBusinessBuilder);

            state.businessBuilder = initialBusinessBuilder;
        },
        setBusinessBuilderAction: (
            state,
            action: PayloadAction<BusinessBuilder>,
        ) => {
            setBusinessBuilder(action.payload);
            state.businessBuilder = action.payload;
        },
    },
});

export const {initializeBusinessAction, setBusinessBuilderAction} =
    NewOrderCreateSlice.actions;
